import {
  BOOKS_LLD_PENDING,
  BOOKS_LLD_FAILED,
  BOOKS_LLD_DOWNLOADED,
  BOOKS_LLD_RESET,
  BOOK_LLD_DOWNLOADED,
  BOOK_LLD_SENDING
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case BOOKS_LLD_PENDING:
      return {
        ...state,
        pending: true,
      };
    case BOOK_LLD_SENDING:
      return {
        ...state,
        sending: true,
      };
    case BOOKS_LLD_FAILED:
      return {
        ...state,
        pending: false,
        sending: false,
        error: action.payload,
      };
    case BOOKS_LLD_DOWNLOADED:
      return {
        ...state,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case BOOK_LLD_DOWNLOADED: {
      const book = action.payload;
      let newState = { ...state };
      const bookIndex = state.content.findIndex(elem => elem.id == book.id);
      if (bookIndex > -1) {
        newState.content.splice(bookIndex, 1, book);
      } else {
        newState.content.push(book);
      }
      return {
        ...newState,
        sending: false,
        pending: false,
      };
    }
    case BOOKS_LLD_RESET:
      return INITIAL_STATE;
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/booksLld/reducers.js